const ROUTES_MAINTENANCE = {
    BASE: {
        name: 'maintenance'
    }
}

export { ROUTES_MAINTENANCE }
